// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3DpiY","alertIcon":"ConfirmModal_alertIcon__2xap7"};